import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { slug } from "@/lib/api";

export function Modal({ title, subtitle, onClose, onSubmit, children, submitLabel = "Simpan", wide = false, testid = "modal", busy = false }) {
  useEffect(() => { const h = (e) => e.key === "Escape" && onClose(); document.addEventListener("keydown", h); return () => document.removeEventListener("keydown", h); }, [onClose]);
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className={`modal ${wide ? "modal-wide" : ""}`} data-testid={testid} onClick={e => e.stopPropagation()}>
        <div className="modal-head">
          <div><h3>{title}</h3>{subtitle && <small>{subtitle}</small>}</div>
          <button className="icon-btn" onClick={onClose} data-testid={`${testid}-close`}><X size={18} /></button>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); onSubmit?.(); }}>
          <div className="modal-body">{children}</div>
          {onSubmit && <div className="modal-foot">
            <button type="button" className="ghost-btn" onClick={onClose}>Batal</button>
            <button type="submit" className="primary-btn small" disabled={busy} data-testid={`${testid}-submit`}>{busy ? "Menyimpan…" : submitLabel}</button>
          </div>}
        </form>
      </div>
    </div>
  );
}

export function TableToolbar({ count, filters = ["Semua", "Aktif", "Pending"], onAdd, addLabel, onFilter, counts }) {
  const [sel, setSel] = useState(0);
  return (
    <div className="module-toolbar">
      <div className="filter-tabs">
        {filters.map((f, i) => (
          <button key={f} data-testid={`filter-${slug(f)}-button`} className={sel === i ? "selected" : ""} onClick={() => { setSel(i); onFilter?.(f, i); }}>
            {f}{i === 0 && count !== undefined && <b>{count}</b>}{i > 0 && counts?.[f] !== undefined && <b>{counts[f]}</b>}
          </button>
        ))}
      </div>
      {onAdd && <button className="primary-btn small" data-testid="module-add-button" onClick={onAdd}><Plus size={15} /> {addLabel}</button>}
    </div>
  );
}

export function PageHeader({ subtitle }) {
  return subtitle ? <p className="subtitle" style={{marginTop:-18,marginBottom:22,fontSize:13,color:"#788597"}}>{subtitle}</p> : null;
}

export function AccessDenied({ module }) {
  return (
    <div className="empty-module" data-testid="access-denied">
      <p><b>Akses dibatasi.</b> Role Anda tidak memiliki izin untuk modul <code>{module}</code>. Hubungi Admin jika Anda memerlukan akses.</p>
    </div>
  );
}

export function RowEditActions({ onEdit, onDelete, locked = false, testid = "row" }) {
  return (
    <div className="row-actions" onClick={e => e.stopPropagation()}>
      <button className="ghost-btn pdf-btn" disabled={locked} title={locked ? "Sudah diproses, tidak dapat diedit" : "Edit"} data-testid={`${testid}-edit`} onClick={onEdit}>Edit</button>
      <button className="ghost-btn pdf-btn danger" disabled={locked} data-testid={`${testid}-delete`} onClick={() => { if (window.confirm("Hapus data ini? Data disimpan sebagai arsip dengan jejak audit.")) onDelete(); }}>Hapus</button>
    </div>
  );
}
